export const PER_SQM_SUFFIX = "_PER_SQM";
export const STORE_SQM_METRIC = "STORE_SQM";
